/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Carousel = __webpack_require__(1);
	var Navigation = __webpack_require__(2);
	var Map = __webpack_require__(3);
	var BtnEntry = __webpack_require__(4);
	
	$(document).ready(function () {
	
	  if ($('.fnc-carousel').length === 1) {
	    Carousel.init();
	  }
	
	  if ($('#fnc-map').length === 1) {
	    Map.init();
	  }
	
	  if ($('.fnc-btnEntry').length === 1) {
	    BtnEntry.init();
	  }
	
	  Navigation.init();
	});

/***/ },
/* 1 */
/***/ function(module, exports) {

	'use strict';
	
	var Carousel = {
	  init: function init() {
	    this.list = $('.fnc-carousel');
	    this.child = this.list.children();
	    this.winWidth = $(window).width();
	    this.imgHeight = this.list.find('img').eq(0).height();
	
	    this.setSlick();
	    this.event();
	
	    TweenMax.to(this.list, 0.5, {
	      opacity: 1,
	      delay: 1,
	      ease: "Linear",
	      onComplete: function onComplete() {},
	      onStart: function onStart() {},
	      onUpdate: function onUpdate() {}
	    });
	  },
	  event: function event() {
	    var _this = this;
	
	    $(window).on('resize.slick', function () {
	      _this.winCheck();
	      _this.reSlick();
	    });
	  },
	  setSlick: function setSlick() {
	    if (window.matchMedia('(min-width: 768px)').matches) {
	      this.list.slick({
	        infinite: true,
	        slidesToShow: 4,
	        slidesToScroll: 1,
	        autoplay: true,
	        autoplaySpeed: 5000,
	        dots: false
	      });
	    } else {
	      // console.log(this.list.width()* 0.49);
	      // this.child.each((i, obj)=>{
	      //   $(obj).find('a').eq(0).css({
	      //     width: this.list.width() * 0.5
	      //   })
	      // });
	      this.list.slick({
	        slidesToShow: 2,
	        slidesToScroll: 1,
	        infinite: true,
	        draggable: true,
	        autoplay: true,
	        autoplaySpeed: 5000,
	        dots: false
	      });
	    }
	  },
	  reSlick: function reSlick() {
	    this.list.slick('unslick');
	    this.setSlick();
	  },
	  winCheck: function winCheck() {
	    this.winWidth = $(window).width();
	  }
	};
	
	module.exports = Carousel;

/***/ },
/* 2 */
/***/ function(module, exports) {

	'use strict';
	
	var Navigation = {
	  init: function init() {
	    this.menu = $('.fnc-navMenu');
	    this.bg = $('.fnc-navMenuBg');
	    this.btnOpen = $('.fnc-navMenuBtn');
	    this.btnClose = $('.fnc-navMenuBtnClose a');
	
	    this.animation = false;
	    this.event();
	  },
	  event: function event() {
	    var _this = this;
	
	    this.btnOpen.on('click', function (e) {
	      e.preventDefault();
	
	      if (!_this.animation) {
	        _this.showBg();
	      }
	    });
	
	    this.btnClose.on('click', function (e) {
	      e.preventDefault();
	      e.stopPropagation();
	
	      if (!_this.animation) {
	        _this.hideNav();
	      }
	    });
	
	    this.bg.on('click', function (e) {
	
	      if (!_this.animation) {
	        _this.hideNav();
	      }
	    });
	
	    $(window).on('resize.slick', function () {
	      if (window.matchMedia('(min-width: 768px)').matches) {
	        _this.reset();
	      }
	    });
	  },
	  hideBg: function hideBg() {
	    var _this2 = this;
	
	    TweenMax.to(this.bg, 0.5, {
	      opacity: 0,
	      ease: "Linear",
	      onComplete: function onComplete() {
	        _this2.animation = false;
	        TweenMax.set(_this2.bg, { display: 'none' });
	        _this2.reset();
	      }
	    });
	  },
	  showBg: function showBg() {
	    var _this3 = this;
	
	    this.animation = true;
	    TweenMax.set(this.bg, { display: 'block' });
	
	    TweenMax.set($('html'), { overflow: 'hidden' });
	
	    TweenMax.to(this.bg, 0.5, {
	      opacity: 0.5,
	      ease: "Linear",
	      onComplete: function onComplete() {
	        _this3.showNav();
	      }
	    });
	  },
	  hideNav: function hideNav() {
	    var _this4 = this;
	
	    this.animation = true;
	    TweenMax.to(this.menu, 0.5, {
	      right: -200,
	      ease: "Linear",
	      onComplete: function onComplete() {
	        TweenMax.set(_this4.menu, { display: 'none' });
	        _this4.hideBg();
	      }
	    });
	  },
	  showNav: function showNav() {
	    var _this5 = this;
	
	    TweenMax.set(this.menu, { display: 'block', right: -200 });
	    TweenMax.to(this.menu, 0.3, {
	      right: 0,
	      ease: "Linear",
	      onComplete: function onComplete() {
	        _this5.animation = false;
	      }
	    });
	  },
	  reset: function reset() {
	    this.menu.removeAttr('style');
	    this.bg.removeAttr('style');
	    $('html').removeAttr('style');
	  },
	  winCheck: function winCheck() {}
	};
	
	module.exports = Navigation;

/***/ },
/* 3 */
/***/ function(module, exports) {

	'use strict';
	
	var Map = {
	  init: function init() {
	    this.mapContaier = $('#fnc-map');
	    this.lat = this.mapContaier.data('lat');
	    this.lng = this.mapContaier.data('lng');
	    this.device = 'pc';
	
	    this.check();
	    this.event();
	    this.render();
	  },
	  event: function event() {
	    var _this = this;
	
	    $(window).on('resize.map', function () {
	      _this.check();
	      _this.render();
	    });
	  },
	  check: function check() {
	    if (window.matchMedia('(min-width: 768px)').matches) {
	      this.device = 'pc';
	    } else {
	      this.device = 'sp';
	    }
	  },
	  render: function render() {
	    var position = { lat: this.lat, lng: this.lng };
	
	    if (this.device === 'pc') {
	      var map = new google.maps.Map(document.getElementById('fnc-map'), {
	        center: position,
	        scrollwheel: false,
	        zoom: 14
	      });
	    } else if (this.device === 'sp') {
	      var map = new google.maps.Map(document.getElementById('fnc-map'), {
	        center: position,
	        scrollwheel: false,
	        zoomControl: false,
	        scaleControl: false,
	        streetViewControl: false,
	        mapTypeControl: false,
	        zoom: 14
	      });
	    }
	
	    var marker = new google.maps.Marker({ map: map, position: position });
	  }
	};
	
	module.exports = Map;

/***/ },
/* 4 */
/***/ function(module, exports) {

	'use strict';
	
	var BtnReserve = {
	  init: function init() {
	    this.btn = $('.fnc-btnEntry');
	    this.cnts = $('.l-contents');
	    this.device = 'pc';
	    this.timer;
	
	    this.cnts.css({
	      paddingBottom: this.btn.outerHeight() + 20
	    });
	
	    if (!window.matchMedia('(min-width: 768px)').matches) {
	      this.device = 'sp;';
	      this.setSp();
	    }
	
	    this.showBtn();
	    this.event();
	  },
	  setSp: function setSp() {
	
	    this.btn.css({
	      position: 'absolute',
	      height: this.btn.outerHeight(),
	      top: this.cnts.outerHeight() + this.cnts.offset().top - this.btn.outerHeight(),
	      bottom: 'inherit'
	    });
	  },
	  event: function event() {
	    var _this = this;
	
	    $(window).on('touchstart.reserve', function () {});
	
	    $(window).on('scroll.reserve', function () {
	
	      if (window.matchMedia('(min-width: 768px)').matches) {
	        _this.checkPos();
	      }
	    });
	
	    $(window).on('resize.reserve', function () {
	
	      _this.cnts.css({
	        paddingBottom: _this.btn.outerHeight() + 20
	      });
	
	      if (!window.matchMedia('(min-width: 768px)').matches) {
	        _this.btn.removeAttr('style');
	        _this.setSp();
	      } else {
	        _this.btn.removeAttr('style');
	        TweenMax.set(_this.btn, { opacity: 1 });
	      }
	    });
	  },
	  showBtn: function showBtn() {
	    TweenMax.set(this.btn, { bottom: -this.btn.outerHeight() });
	    if (window.matchMedia('(min-width: 768px)').matches) {
	      TweenMax.to(this.btn, 0.5, { ease: Power4.easeOut, bottom: 0, opacity: 1 });
	    }
	  },
	  checkPos: function checkPos() {
	    if ($(window).scrollTop() + $(window).height() > this.cnts.outerHeight() + this.cnts.offset().top) {
	      this.btn.addClass('is-fixed');
	      this.btn.css({
	        position: 'absolute',
	        top: this.cnts.outerHeight() + this.cnts.offset().top - this.btn.outerHeight(),
	        bottom: 'inherit'
	      });
	    } else {
	      this.btn.removeClass('is-fixed');
	      this.btn.css({
	        position: 'fixed',
	        top: 'inherit',
	        bottom: 0
	      });
	    }
	  }
	};
	
	module.exports = BtnReserve;

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// js/app.js